import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
const PRIORITY_CONFIG = {
    stat: {
        labelKey: 'priority.stat',
        className: 'bg-red-500/15 text-red-400 ring-red-500/30 ring-1',
    },
    urgent: {
        labelKey: 'priority.urgent',
        className: 'bg-amber-500/15 text-amber-400 ring-amber-500/30 ring-1',
    },
    routine: {
        labelKey: 'priority.routine',
        className: 'bg-emerald-500/15 text-emerald-400 ring-emerald-500/30 ring-1',
    },
};
export function PriorityBadge({ priority }) {
    const { t } = useTranslation('teleconsultation');
    const config = PRIORITY_CONFIG[priority];
    return (_jsx("span", { className: cn('inline-flex items-center rounded-full px-1.5 py-0.5 text-[10px] font-bold', config.className), children: t(config.labelKey) }));
}
